import { useTranslation } from 'react-i18next';
import { i18nNS } from '../i18n';

const useTextTripFilter = () => {
  const { t } = useTranslation(i18nNS.myTrips);

  const filters = [
    {
      label: t('myTrips:MyTripsScreen.AllTrips'),
      value: 'AllTrips',
    },
    {
      label: t('myTrips:MyTripsScreen.Pending'),
      value: 'Pending',
    },
    {
      label: t('myTrips:MyTripsScreen.UpcomingPurchase'),
      value: 'Purchased',
    },
    {
      label: t('myTrips:MyTripsScreen.Past'),
      value: 'Past',
    },
    {
      label: t('myTrips:MyTripsScreen.Approved'),
      value: 'Approved',
    },
    {
      label: t('myTrips:MyTripsScreen.Canceled'),
      value: 'Canceled',
    },
    {
      label: t('myTrips:MyTripsScreen.PendingApproval'),
      value: 'PendingApproval',
    },
    {
      label: t('myTrips:MyTripsScreen.PendingCancel'),
      value: 'PendingCancel',
    },
    {
      label: t('myTrips:MyTripsScreen.PendingCreditCardIssue'),
      value: 'PendingCreditCardIssue',
    },
  ];

  return [filters];
};

export default useTextTripFilter;
